import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {
  Box,
  IconButton,
  LinearProgress,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { isEmpty, isNil } from 'lodash';
import { useId, type FC } from 'react';
import type { LinearProgressProps } from '@mui/material';

export interface UploadProgressProps {
  progress: number;
  fileName?: string;
  onCancel?: VoidFunction;
}

const LinearProgressWithLabel: FC<
  LinearProgressProps & { value: number; onCancel?: VoidFunction }
> = ({ onCancel, ...props }) => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <Box sx={{ width: '100%', mr: 1 }}>
      <LinearProgress variant='determinate' {...props} />
    </Box>
    <Stack sx={{ minWidth: 35 }} direction={'row'} gap={0.5} alignItems={'center'}>
      <Typography variant='body2' color='text.secondary'>{`${Math.round(
        props.value
      )}%`}</Typography>
      {!isNil(onCancel) && (
        <Tooltip title='Отменить загрузку'>
          <IconButton aria-label='delete' size='small' onClick={onCancel}>
            <CancelOutlinedIcon fontSize='small' />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  </Box>
);

const UploadProgress: FC<UploadProgressProps> = ({ progress, fileName, onCancel }) => {
  const componentId = useId();

  return (
    <Box sx={{ width: '100%' }}>
      {!isEmpty(fileName) && (
        <Typography variant='caption' display={'block'} id={`${componentId}-label`}>
          {fileName}
        </Typography>
      )}
      <LinearProgressWithLabel
        value={progress}
        onCancel={onCancel}
        aria-labelledby={isEmpty(fileName) ? undefined : `${componentId}-label`}
      />
    </Box>
  );
};

export default UploadProgress;
